import React from 'react';
import device from 'current-device';
import { Helmet } from 'react-helmet';

export const getQueryStringValue = (key) => {
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}
//To find current device is running on which type
export const isMobile = () => {
    return device.type === "mobile" ? true : false;
}

//To find current device is running on which iOS
export const deviceType = () => {
    return device;
}
//To find current device is running on which iOS
export const isDesktop = () => {
    return device.type === "desktop" ? true : false;
}

export const isIos = () => {
    /* istanbul ignore next */
    return ((device.type === "tablet" || device.type === "mobile") && (device.os === "ios" || device.os === "ipad")) ? true : false;
}

//To convert Html unicode characters to symbols
export const unescapeHtml = (str) => {
    const map = { amp: '&', lt: '<', le: '≤', gt: '>', ge: '≥', quot: '"', '#039': "'" }
    return str ? str.replace(/&([^;]+);/g, (m, c) => map[c] || '') : '';
}

export const updatePlpOrigin = (key, value) => {
    localStorage.setItem(key, value);
}

export const removeLocalStorageItem = (key) => {
    localStorage.removeItem(key);
}

export const addToQueryString = (url, key, value) => {
    var query = url.indexOf('?');
    var anchor = url.indexOf('#');
    if (query === url.length - 1) {
      // Strip any ? on the end of the URL
      url = url.substring(0, query);
      query = -1;
    }
    return (anchor > 0 ? url.substring(0, anchor) : url)
        + (query > 0 ? "&" + key + "=" + value : "?" + key + "=" + value)
        + (anchor > 0 ? url.substring(anchor) : "");
}


export const sort = (arr, key) => {
    if (arr && key) {
        return arr.sort(function (a, b) {
            if (a[key] < b[key]) { return -1; }
            if (a[key] > b[key]) { return 1; }
            return 0;
        });
    }
        return arr;
}

export const getCountryCodeAndRetailerId = () => {
    return window.location.pathname.split('/')[1];
}

export const debounce = (func, delay) => {
    let debounceTimer
    return function() {
        const context = this
        const args = arguments
            clearTimeout(debounceTimer)
                debounceTimer
            = setTimeout(() => func.apply(context, args), delay)
    }
}

export const globalEventListner = () => {
    document.body.addEventListener("keydown", function(event){
        /* istanbul ignore next */
        if(event.key === "Enter"){
          event.target.click();
          if(event.target.className.includes('product_remove_btn')){
              event.stopPropagation();
              event.preventDefault();
          }
        }
      })
}

export const pushPageView = (pageName) => {
    // if(dataLayer){
    //     dataLayer.push({'event':'pageview', page: {
    //         path: window.location.href,
    //         title: pageName
    //       } })
    // }
}

export const metaTags = (pageTitle, pageDesc) => {
    // pushPageView(pageTitle);
    return (
        <Helmet>
            <meta charSet="utf-8" />
            <title> { pageTitle } </title>
            <meta name="description" content={pageDesc} />
            <link rel="canonical" href={window.location.href} />
        </Helmet>
    )
}